import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { MasterBlockId } from 'src/shared/types/base-entity-interface'
import { LanguageSwitcherInterface } from 'common/types/entities/LanguageSwitcherInterface'
import { generateBaseEntity } from 'src/shared/entities/utils/generate-base-entity'

export function createLanguageSwitcher(
  parentId: string,
  masterBlockId?: MasterBlockId,
): LanguageSwitcherInterface {
  return {
    ...generateBaseEntity(
      EntityTypeEnum.LanguageSwitcher,
      parentId,
      masterBlockId,
    ),
    excludedLanguages: [],
    redirectPath: '',
    fontSize: 16,
    color: 'rgba(149, 164, 186, 1)',
  }
}
